/* FAIRYDUST — bag milestones, the look only (amounts and codes are handled in fairydust.js).
   ts: [{k, at (cents, shopper's currency), label, phrase}] in ascending order.
   One status line + one slim rail; each milestone is the logo sparkle centred over its own label,
   so markers and labels can never drift apart. Reached = gold sparkle, not yet = outlined. */
window.fdTiersHtml = function(amount, ts, u){
  var n = ts.length; if(!n) return '';
  var next = null, prev = null;
  for(var i=0;i<n;i++){ if(amount<ts[i].at){ next=ts[i]; break; } prev=ts[i]; }
  var whole = function(c){ return u.money(c).replace(/[.,]00(?=\D*$)/,''); };
  var tt = u.tr || function(k,d,o){ var s=d; if(o) for(var x in o) s=s.split('{'+x+'}').join(o[x]); return s; };
  /* screen-reader word for a reached milestone, in the page language */
  var ON = ({de:'freigeschaltet', fr:'débloqué'})[(document.documentElement.lang||'en').slice(0,2)] || 'unlocked';
  var SPARK = '<span class="fd-tiers__spark" aria-hidden="true">✦</span> ';
  /* far from the next milestone: name what's already unlocked; past halfway: count down what's left
     (people push harder on the part of the goal that looks smaller, Koo & Fishbach 2012) */
  var far = next && prev && (amount-prev.at) < (next.at-prev.at)/2;
  var msg = !next
    ? SPARK+tt('unlocked','You’ve unlocked {reward}',{reward:'<em>'+u.esc(ts[n-1].phrase)+'</em>'})
    : far
      ? SPARK+tt('unlocked','You’ve unlocked {reward}',{reward:'<em>'+u.esc(prev.phrase)+'</em>'})+' · '+tt('next_at','next at {amount}',{amount:whole(next.show||next.at)})
      : tt('away','{amount} away from {reward}',{amount:'<b>'+u.money(Math.ceil((next.at-amount)/100)*100)+'</b>',reward:'<em>'+u.esc(next.phrase)+'</em>'});
  /* markers sit at the centre of equal columns: (2i+1)/2n; fill runs marker to marker */
  var pos = function(i){ return (2*i+1)/(2*n)*100; };
  var fill = 100, prevAt = 0, prevPos = 0;
  for(var j=0;j<n;j++){
    if(amount<ts[j].at){ fill = prevPos + (pos(j)-prevPos)*Math.max(0,(amount-prevAt)/(ts[j].at-prevAt)); break; }
    prevAt = ts[j].at; prevPos = pos(j);
  }
  var STAR = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 .4C6.5 3.7 8.3 5.5 11.6 6 8.3 6.5 6.5 8.3 6 11.6 5.5 8.3 3.7 6.5.4 6 3.7 5.5 5.5 3.7 6 .4z"/></svg>';
  var marks = ts.map(function(t){
    var on = amount>=t.at, cls = on ? ' is-on' : (t===next ? ' is-next' : '');
    return '<li class="fd-tiers__m'+cls+'"><span class="fd-tiers__dot">'+STAR+'</span>'+
      '<span class="fd-tiers__l">'+u.esc(t.label)+'</span>'+
      '<span class="fd-tiers__v">'+(t.at?whole(t.show||t.at):tt('every_order','Every order'))+(on?'<span class="sr-only"> ('+ON+')</span>':'')+'</span></li>';
  }).join('');
  return '<p class="fd-tiers__msg">'+msg+'</p>'+
    '<div class="fd-tiers__rail"><span class="fd-tiers__line"><span style="width:'+fill.toFixed(1)+'%"></span></span>'+
    '<ol class="fd-tiers__marks" style="grid-template-columns:repeat('+n+',1fr)">'+marks+'</ol></div>';
};
